import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-complete-activity-dialog',
  templateUrl: './complete-activity-dialog.component.html',
  styleUrls: ['./complete-activity-dialog.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0, height: '0px', overflow: 'hidden' })),
      state('*', style({ opacity: 1, height: '*', overflow: 'auto' })),
      transition('* <=> void', animate('500ms ease-in-out')),
    ])
  ]  
})
export class CompleteActivityDialogComponent implements OnInit {

  form: FormGroup;

  
  constructor(
    public dialogRef: MatDialogRef<CompleteActivityDialogComponent>,
    private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      status: ['KO'],
      comment: ['']
    });
  }

  ngOnInit() {
  }


  onOkClick(): void {
    this.form.get('status').setValue('OK');
  }

  onKoClick(): void {
    this.form.get('status').setValue('KO');
  }

  confirm(): void {
    const result = this.form.value.status === 'KO' ? {status: 'KO', comment: this.form.value.comment} : {status: 'OK', comment: null};
    this.dialogRef.close(result);
  }

  onDismiss() : void {
    this.dialogRef.close();
  }

  get commentControl(): FormControl {
    return this.form.get('comment') as FormControl;
  }
}
